import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import _ from 'lodash';
import Arrow from 'assets/images/arrowRight.svg';
import { TABLET_WIDTH } from 'constants/breakPoints';
import { Content, ButtonScroll } from './styles';

const DIRECTION_RIGHT = 'right';
const DIRECTION_LEFT = 'left';
function SimpleCarousel(props) {
  const {
    children, classesList, defaultPosition, onChangeSlide, showButtons,
  } = props;

  const [classIdName, setClassIdName] = useState(null);
  const [tries, setTries] = useState(0);
  const [fitAllElements, setFitAllElements] = useState(true);
  const [isDragging, setIsDragging] = useState(false);
  const [numChildren, setNumChildren] = useState(0);

  useEffect(() => {
    setClassIdName(`simple_carousel_${Math.round(Math.random() * 999999)}`);
  }, []);

  let toTry = null;

  useEffect(() => {
    if (!window.$(`.${classesList}`).length) {
      toTry = setTimeout(() => {
        setTries(tries + 1);
      }, 300);
    }

    return (() => {
      if (toTry) {
        clearTimeout(toTry);
      }
    });
  }, [tries]);

  const [actualSlide, setActualSlide] = useState(0);
  useEffect(() => {
    setActualSlide(Math.max(0, defaultPosition));
  }, [defaultPosition]);


  // events
  const handleDrag = () => {
    setIsDragging(true);
    if (onChangeSlide) {
      let scroll = 0;
      if (window.$(`.${classIdName}:first`).hasClass('is_draggable')) {
        scroll = Math.abs(parseInt(window.$(`.${classIdName}:first > div:first`).css('transform').split(',')[4].trim(), 10));
      } else {
        scroll = window.$(`.${classIdName}`).scrollLeft();
      }

      const widthCard = window.$(`.${classesList}:first`).outerWidth() + 10;
      const actualCard = Math.floor(scroll / widthCard);
      if (actualCard !== actualSlide) {
        setActualSlide(actualCard);
        onChangeSlide(actualCard);
      }
    }
  };

  const handleStop = () => {
    setTimeout(() => { setIsDragging(false); }, 0);
  };

  const getCarouselBounds = () => {
    const widthCard = window.$(`.${classesList}:first`).outerWidth();
    const widthParent = window.$(`.${classesList}:first`).parent().outerWidth();
    const elementsVisibles = widthParent / widthCard;
    const totalElements = window.$(`.${classesList}:first`).parent().children().length;
    const offsetElements = Math.max(0, defaultPosition - Math.max(0, (totalElements - elementsVisibles)));

    const left = totalElements <= elementsVisibles ? 0 : ((totalElements - elementsVisibles) * widthCard * (-1) - 40 - (offsetElements * widthCard));

    if (totalElements <= elementsVisibles) {
      if (!fitAllElements) {
        setFitAllElements(true);
      }
    } else if (fitAllElements) {
      setFitAllElements(false);
    }

    return {
      right: 0,
      left,
    };
  };

  const getDefaultPosition = () => {
    const position = Math.max(0, defaultPosition);
    const bounds = getCarouselBounds();
    let x = 0;

    const width = window.$(`.${classesList}:first`).outerWidth();
    if (position > 0 && !Number.isNaN(bounds.left) && !Number.isNaN(bounds.right)) {
      x = (position * (width + 10)) * (-1);
      x = _.clamp(x, bounds.left, bounds.right);
    }

    return { x, y: 0 };
  };

  const setDefaultScrollPosition = (position) => {
    if (!window.$(`.${classIdName}:first`).hasClass('has_scrolled')) {
      window.$(`.${classIdName}:first`).addClass('has_scrolled');
      setTimeout(() => {
        window.$(`.${classIdName}:first`).scrollLeft(Math.abs(position));
      }, 100);
    }
  };


  // Arrows handler
  let toScroll = null;
  const [scrollDirection, setScrollDirection] = useState(null);
  const startScrollRight = () => {
    setScrollDirection(DIRECTION_RIGHT);
  };

  const stopScrollRight = () => {
    setScrollDirection(null);
  };

  const startScrollLeft = () => {
    setScrollDirection(DIRECTION_LEFT);
  };

  const stopScrollLeft = () => {
    setScrollDirection(null);
  };

  useEffect(() => {
    const bounds = getCarouselBounds();
    if (!scrollDirection) {
      if (toScroll) {
        clearInterval(toScroll);
      }
    } else {
      toScroll = setInterval(() => {
        const transformArray = window.$(`.${classIdName}:first > div:first`).css('transform').split(',');
        let scroll = parseInt(transformArray[4].trim(), 10);
        const movement = scrollDirection === DIRECTION_LEFT ? 10 : -10;
        scroll += movement;
        scroll = Math.max(Math.min(0, scroll), bounds.left);
        transformArray[4] = scroll;
        window.$(`.${classIdName}:first > div:first`).css('transform', transformArray.join(','));
      }, 10);
    }


    return (() => {
      if (toScroll) {
        clearInterval(toScroll);
      }
    });
  }, [scrollDirection]);

  useEffect(() => {
    if (children.length !== numChildren) {
      if (children.length < numChildren) {
        const transformArray = window.$(`.${classIdName}:first > div:first`).css('transform').split(',');
        transformArray[4] = 0;
        window.$(`.${classIdName}:first > div:first`).css('transform', transformArray.join(','));
      }
      setNumChildren(children.length);
    }
  }, [children]);

  let content;
  const positionCoords = getDefaultPosition();
  const bounds = getCarouselBounds();
  if (window.innerWidth > TABLET_WIDTH && window.$(`.${classesList}`).length && !Number.isNaN(bounds.left)) {
    content = (
      <div style={{ position: 'relative' }}>
        {showButtons && !fitAllElements ? (
          <ButtonScroll direction='left' onMouseDown={startScrollLeft} onMouseUp={stopScrollLeft}>
            <img className='left' src={Arrow} alt='' />
          </ButtonScroll>
        ) : null}
        <Content className={`nowrap simple_carousel ${classIdName} is_draggable`}>
          <Draggable axis='x' bounds={bounds} defaultPosition={positionCoords} onDrag={handleDrag} onStop={handleStop}>
            <div>
              {React.Children.map(children, child => (
                React.cloneElement(child, { isDragging })
              ))}
            </div>
          </Draggable>
        </Content>
        {showButtons && !fitAllElements ? (
          <ButtonScroll direction='right' onMouseDown={startScrollRight} onMouseUp={stopScrollRight}>
            <img src={Arrow} alt='' />
          </ButtonScroll>
        ) : null}
      </div>
    );
  } else {
    content = (
      <Content className={`nowrap simple_carousel ${classIdName}`} onScroll={handleDrag}>
        {children}
      </Content>
    );

    if (positionCoords.x !== 0) {
      setDefaultScrollPosition(positionCoords.x);
    }
  }
  return content;
}

SimpleCarousel.propTypes = {
  defaultPosition: PropTypes.number,
  classesList: PropTypes.string.isRequired,
  onChangeSlide: PropTypes.func,
  showButtons: PropTypes.bool,
};

SimpleCarousel.defaultProps = {
  defaultPosition: 0,
  onChangeSlide: null,
  showButtons: false,
};

export default SimpleCarousel;



// WEBPACK FOOTER //
// ./src/components/SimpleCarousel/components/index.jsx